<template>
  <AllegroJsonForm
    title="Allegro - Edytuj OAuth"
    crumbLabel="Edycja OAuth"
    :settingsCrumb="true"
    submitAction="updateAllegroOauth"
    submitGetter="getAllegroOauthUpdateData"
    loadAction="getAllConf"
    loadGetter="getAllConfDetailsData"
    :isUpdate="true"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
    :emptyObjects="['user_agent']"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroConfigPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroOauthUpdate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroConfigPermissionsConst.update,
      fields: [
        {
          key: "user_agent.app_name",
          label: "Nazwa aplikacji",
          required: true,
        },
        {
          key: "user_agent.app_version",
          label: "Wersja aplikacji",
          required: true,
        },
        {
          key: "user_agent.url",
          label: "Adres strony kontaktowej",
          required: true,
        },
        { key: "client_id", label: "Client ID", required: true },
        { key: "client_secret", label: "Client secret", required: true },
        { key: "base_url", label: "Adres do autoryzacji", required: true },
        { key: "base_api_url", label: "Adres do API", required: true },
      ],
    };
  },
};
</script>
